import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { WorkflowNavigation } from 'Organisms/WorkflowNavigation';
import PropTypes from 'prop-types';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('WizardLayout', ((theme) => ({
  title: {
    '& .FD-MuiTypography-root': {
      fontWeight: theme.typography.fontWeightExtraBold,
    },
  },
})));

export const WizardLayout = ({
  children,
  description,
  aboveTitle,
  belowSubtitle,
}) => {
  const { pageContentResource } = usePageContentContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();

  useBoneBackgroundColor();

  return (
    <>
      <WorkflowNavigation resource={pageContentResource} />
      <FDStack direction={'column'} alignItems={'center'} spacing={isMobile ? 6 : 8} paddingX={isMobile ? 2 : 6} paddingY={isMobile ? 6 : 8}>
        <FDContentContainer maxWidth={'md'}>
          <FDStack direction={'column'} alignItems={'center'} spacing={4}>
            <FDStack direction={'column'} alignItems={'center'} spacing={2}>
              {aboveTitle}
              <div className={classes.title}>
                <MetaControlField attr={'title'} />
              </div>
              <MetaControlField attr={'subtitle'} />
              {belowSubtitle}
            </FDStack>
            {description || <MetaControlField attr={'description'} />}
          </FDStack>
        </FDContentContainer>
        {children}
        <FDContentContainer maxWidth={'md'}>
          <MetaControlField attr={'disclosure'} />
        </FDContentContainer>
      </FDStack>
    </>
  );
};

WizardLayout.propTypes = {
  description: undefined,
  aboveTitle: undefined,
  belowSubtitle: undefined,
};

WizardLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  description: PropTypes.node,
  aboveTitle: PropTypes.node,
  belowSubtitle: PropTypes.node,
};
